var exports = {
  "x6": "GuildListActionButton.module__button___dXZXMH",
  "td": "GuildListActionButton.module__iconText___dXZXMH",
  "ro": "GuildListActionButton.module__menuIcon___dXZXMH",
};

module.exports = exports;
